function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useMemo, useState } from 'react';
import { ActiveServicesReportEntryApiAutomaticServiceState, ActiveServicesReportEntryApiOccurrence, ActiveServicesReportEntryApiPricing, ActiveServicesReportEntryApiStatus, ActiveServicesReportEntryApiTrigger } from 'anchor-scout/types';
import { Link, useHistory } from 'react-router-dom';
import { Button, Checkbox, DropdownMenu, FilterPicker, FilterPickerGroup, KeyboardDatePicker, MultiSelectFilterPicker, Page, PageContentHeader, RadioButtonWithLabel, Spinner, TableList, TextButton, Typography } from 'seagull';
import { routes } from "../../../constants";
import { useIoContext, useStore, useStoreActions } from "../../../contexts";
import { selectors } from "../../../store/state-selectors";
import styles from "./ActiveServices.module.scss";
import compact from 'lodash/compact';
import { startOfDay, subMonths } from 'date-fns';
import isEqual from 'lodash/isEqual';
import { formatShortUSDate } from "../../../utils";
import { exportCsv } from "../../../utils/csv.utils";
const title = 'Active Services Report';
var ActiveServicesReportOptionalColumns = /*#__PURE__*/function (ActiveServicesReportOptionalColumns) {
  ActiveServicesReportOptionalColumns["Trigger"] = "Trigger";
  ActiveServicesReportOptionalColumns["Pricing"] = "Pricing";
  ActiveServicesReportOptionalColumns["Occurrence"] = "Occurrence";
  ActiveServicesReportOptionalColumns["Rate"] = "Rate";
  ActiveServicesReportOptionalColumns["LastBilled"] = "Last billed";
  ActiveServicesReportOptionalColumns["Assignee"] = "Assignee";
  ActiveServicesReportOptionalColumns["AutomaticServiceState"] = "Automatic service state";
  ActiveServicesReportOptionalColumns["Status"] = "Status";
  return ActiveServicesReportOptionalColumns;
}(ActiveServicesReportOptionalColumns || {});
function ActiveServiceRow(props) {
  const {
    visibleColumns,
    data
  } = props;
  const items = compact([{
    value: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
      as: Link,
      to: routes.agreement(data.relationshipId),
      "data-testid": "active-services-report-row-customer",
      variant: "paragraph1",
      noWrap: true,
      ellipsis: true
    }, data.customerName), /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "active-services-report-row-agreement",
      variant: "paragraph2",
      skin: "secondary"
    }, data.agreementName))
  }, {
    value: /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "active-services-report-row-service",
      variant: "paragraph1",
      noWrap: true,
      ellipsis: true
    }, data.serviceName)
  }, visibleColumns[ActiveServicesReportOptionalColumns.Trigger] && {
    value: /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "active-services-report-row-trigger",
      variant: "paragraph1",
      noWrap: true
    }, data.trigger)
  }, visibleColumns[ActiveServicesReportOptionalColumns.Pricing] && {
    value: /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "active-services-report-row-pricing",
      variant: "paragraph1",
      noWrap: true
    }, data.pricing)
  }, visibleColumns[ActiveServicesReportOptionalColumns.Occurrence] && {
    value: /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "active-services-report-row-occurrence",
      variant: "paragraph1",
      noWrap: true
    }, data.occurrence)
  }, visibleColumns[ActiveServicesReportOptionalColumns.Rate] && {
    value: /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "active-services-report-row-rate",
      variant: "paragraph1",
      noWrap: true
    }, data.rate)
  }, visibleColumns[ActiveServicesReportOptionalColumns.LastBilled] && {
    value: /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "active-services-report-row-last-billed",
      variant: "paragraph1",
      noWrap: true
    }, data.formattedLastBilled)
  }, visibleColumns[ActiveServicesReportOptionalColumns.Assignee] && {
    value: /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "active-services-report-row-assignee",
      variant: "paragraph1",
      noWrap: true
    }, data.assignee)
  }, visibleColumns[ActiveServicesReportOptionalColumns.AutomaticServiceState] && {
    value: /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "active-services-report-row-paused",
      variant: "paragraph1",
      noWrap: true
    }, data.automaticServiceState == null ? '-' : data.automaticServiceState)
  }, visibleColumns[ActiveServicesReportOptionalColumns.Status] && {
    value: /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "active-services-report-row-status",
      variant: "paragraph1",
      noWrap: true
    }, data.status)
  }]);
  return /*#__PURE__*/React.createElement(TableList.Row, {
    items: items,
    rowId: props.index,
    "data-testid": "active-services-report-row-".concat(props.index),
    "data-heapid": "active-services-report-row"
  });
}
function activeServicesReportHeaderColumnDefsForExport(visibleColumns) {
  return compact([{
    value: 'Company name'
  }, {
    value: 'Agreement name'
  }, {
    value: 'Service name'
  }, visibleColumns[ActiveServicesReportOptionalColumns.Trigger] && {
    value: 'Trigger'
  }, visibleColumns[ActiveServicesReportOptionalColumns.Pricing] && {
    value: 'Pricing'
  }, visibleColumns[ActiveServicesReportOptionalColumns.Occurrence] && {
    value: 'Occurrence'
  }, visibleColumns[ActiveServicesReportOptionalColumns.Rate] && {
    value: 'Rate'
  }, visibleColumns[ActiveServicesReportOptionalColumns.LastBilled] && {
    value: 'Last billed'
  }, visibleColumns[ActiveServicesReportOptionalColumns.Assignee] && {
    value: 'Assignee'
  }, visibleColumns[ActiveServicesReportOptionalColumns.AutomaticServiceState] && {
    value: 'Automatic service state'
  }, visibleColumns[ActiveServicesReportOptionalColumns.Status] && {
    value: 'Status'
  }]);
}
function activeServicesReportHeaderColumnDefs(visibleColumns) {
  return compact([{
    value: 'Company name'
  }, {
    value: 'Service name'
  }, visibleColumns[ActiveServicesReportOptionalColumns.Trigger] && {
    value: 'Trigger'
  }, visibleColumns[ActiveServicesReportOptionalColumns.Pricing] && {
    value: 'Pricing'
  }, visibleColumns[ActiveServicesReportOptionalColumns.Occurrence] && {
    value: 'Occurrence'
  }, visibleColumns[ActiveServicesReportOptionalColumns.Rate] && {
    value: 'Rate'
  }, visibleColumns[ActiveServicesReportOptionalColumns.LastBilled] && {
    value: 'Last billed'
  }, visibleColumns[ActiveServicesReportOptionalColumns.Assignee] && {
    value: 'Assignee'
  }, visibleColumns[ActiveServicesReportOptionalColumns.AutomaticServiceState] && {
    value: 'Automatic service state'
  }, visibleColumns[ActiveServicesReportOptionalColumns.Status] && {
    value: 'Status'
  }]);
}
function activeServicesReportColumnDefs(visibleColumns) {
  return compact([{
    width: 234,
    sortable: false
  }, {
    width: 234,
    sortable: false
  }, visibleColumns[ActiveServicesReportOptionalColumns.Trigger] && {
    width: 108,
    sortable: false
  }, visibleColumns[ActiveServicesReportOptionalColumns.Pricing] && {
    width: 108,
    sortable: false
  }, visibleColumns[ActiveServicesReportOptionalColumns.Occurrence] && {
    width: 108,
    sortable: false
  }, visibleColumns[ActiveServicesReportOptionalColumns.Rate] && {
    width: 148,
    sortable: false
  }, visibleColumns[ActiveServicesReportOptionalColumns.LastBilled] && {
    width: 148,
    sortable: false
  }, visibleColumns[ActiveServicesReportOptionalColumns.Assignee] && {
    width: 180,
    sortable: false
  }, visibleColumns[ActiveServicesReportOptionalColumns.AutomaticServiceState] && {
    width: 180,
    sortable: false
  }, visibleColumns[ActiveServicesReportOptionalColumns.Status] && {
    width: 108,
    sortable: false
  }]);
}
function VisibleColumnsPicker(props) {
  const [selectedColumns, setSelectedColumns] = useState(props.visibleColumns);
  const numSelectedColumns = useMemo(() => Object.values(selectedColumns).filter(value => value).length, [selectedColumns]);
  return /*#__PURE__*/React.createElement(FilterPicker, {
    "data-testid": "active-services-report-column-selector",
    label: numSelectedColumns > 0 ? "".concat(numSelectedColumns, " columns selected") : 'None selected',
    title: "Additional columns",
    highlightTrigger: false,
    onApply: () => props.onApply(selectedColumns),
    onClose: () => {}
  }, Object.entries(selectedColumns).map(_ref => {
    let [name, selected] = _ref;
    return /*#__PURE__*/React.createElement(Checkbox, {
      key: name,
      name: name,
      "data-testid": "active-services-report-column-picker-".concat(name.toLowerCase()),
      checked: selected,
      onChange: () => {
        setSelectedColumns(_objectSpread(_objectSpread({}, selectedColumns), {}, {
          [name]: !selected
        }));
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "paragraph1"
    }, name));
  }));
}
var FilterType = /*#__PURE__*/function (FilterType) {
  FilterType["CustomerName"] = "company";
  FilterType["AgreementName"] = "agreement";
  FilterType["ServiceName"] = "service";
  FilterType["Occurrence"] = "occurrence";
  FilterType["Trigger"] = "trigger";
  FilterType["Pricing"] = "pricing";
  FilterType["LastBilled"] = "lastBilled";
  FilterType["Assignee"] = "assignee";
  FilterType["AutomaticServiceState"] = "automaticServiceState";
  FilterType["Status"] = "status";
  return FilterType;
}(FilterType || {});
const filterLabels = {
  [FilterType.CustomerName]: 'Company name',
  [FilterType.AgreementName]: 'Agreement name',
  [FilterType.ServiceName]: 'Service name',
  [FilterType.Occurrence]: 'Occurrence',
  [FilterType.Trigger]: 'Trigger',
  [FilterType.Pricing]: 'Pricing',
  [FilterType.LastBilled]: 'Last billed',
  [FilterType.Assignee]: 'Assignee',
  [FilterType.AutomaticServiceState]: 'Automatic service state',
  [FilterType.Status]: 'Status'
};
export function FilterSelector(props) {
  const {
    selected,
    onSelect
  } = props;
  const items = useMemo(() => {
    const getEntry = (type, text) => ({
      type,
      text,
      disabled: selected.includes(type)
    });
    const items = Object.values(FilterType).map(key => {
      //const type = FilterType[key as keyof typeof FilterType];
      return getEntry(key, filterLabels[key]);
    });
    return items;
  }, [selected]);
  function getMenuItem(type, text, disabled) {
    return /*#__PURE__*/React.createElement(DropdownMenu.Item, {
      key: type,
      skin: "primary",
      "data-testid": "active-services-report-filter-picker-".concat(type),
      disabled: disabled,
      onClick: () => onSelect(type)
    }, text);
  }
  return /*#__PURE__*/React.createElement(DropdownMenu, {
    "data-testid": "active-services-report-filter-picker",
    hAlign: "center",
    target: /*#__PURE__*/React.createElement(TextButton, {
      "data-testid": "active-services-report-add-filter",
      underline: "hover"
    }, "+Add filter")
  }, items.map(_ref2 => {
    let {
      type,
      text,
      disabled
    } = _ref2;
    return getMenuItem(type, text, disabled);
  }));
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getSimpleMultiSelectFilterConfig(type, component) {
  return {
    component,
    hasValue(v) {
      return v.length > 0;
    },
    getEmptyValue() {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return [];
    },
    serialize(data) {
      return {
        [type]: data
      };
    }
  };
}
const occurrenceFilterOptions = [{
  label: 'One-time',
  value: ActiveServicesReportEntryApiOccurrence.OneTime
}, {
  label: 'Weekly',
  value: ActiveServicesReportEntryApiOccurrence.Weekly
}, {
  label: 'Bi-weekly',
  value: ActiveServicesReportEntryApiOccurrence.BiWeekly
}, {
  label: 'Monthly',
  value: ActiveServicesReportEntryApiOccurrence.Monthly
}, {
  label: 'Quarterly',
  value: ActiveServicesReportEntryApiOccurrence.Quarterly
}, {
  label: 'Yearly',
  value: ActiveServicesReportEntryApiOccurrence.Yearly
}];
function OccurrenceFilter(props) {
  return /*#__PURE__*/React.createElement(MultiSelectFilterPicker, {
    removable: true,
    startOpen: props.startOpen,
    "data-testid": "active-services-report-occurrence-filter",
    value: props.value,
    options: occurrenceFilterOptions,
    label: filterLabels[FilterType.Occurrence],
    onChange: props.onChange,
    onRemove: props.onRemove
  });
}
const triggerFilterOptions = [{
  label: 'Manual',
  value: ActiveServicesReportEntryApiTrigger.Manual
}, {
  label: 'Automatic',
  value: ActiveServicesReportEntryApiTrigger.Automatic
}];
function TriggerFilter(props) {
  return /*#__PURE__*/React.createElement(MultiSelectFilterPicker, {
    removable: true,
    startOpen: props.startOpen,
    "data-testid": "active-services-report-trigger-filter",
    value: props.value,
    options: triggerFilterOptions,
    label: filterLabels[FilterType.Trigger],
    onChange: props.onChange,
    onRemove: props.onRemove
  });
}
const pricingFilterOptions = [{
  label: 'Fixed',
  value: ActiveServicesReportEntryApiPricing.Fixed
}, {
  label: 'Per hour',
  value: ActiveServicesReportEntryApiPricing.PerHour
}, {
  label: 'Per unit',
  value: ActiveServicesReportEntryApiPricing.PerUnit
}, {
  label: 'Range',
  value: ActiveServicesReportEntryApiPricing.Range
}];
function PricingFilter(props) {
  return /*#__PURE__*/React.createElement(MultiSelectFilterPicker, {
    removable: true,
    startOpen: props.startOpen,
    "data-testid": "active-services-report-pricing-filter",
    value: props.value,
    options: pricingFilterOptions,
    label: filterLabels[FilterType.Pricing],
    onChange: props.onChange,
    onRemove: props.onRemove
  });
}
const pausedFilterOptions = [{
  label: 'Paused',
  value: ActiveServicesReportEntryApiAutomaticServiceState.Paused
}, {
  label: 'Active',
  value: ActiveServicesReportEntryApiAutomaticServiceState.Active
}];
function AutomaticServiceStatusFilter(props) {
  return /*#__PURE__*/React.createElement(MultiSelectFilterPicker, {
    removable: true,
    startOpen: props.startOpen,
    "data-testid": "active-services-report-paused-filter",
    value: props.value,
    options: pausedFilterOptions,
    label: filterLabels[FilterType.AutomaticServiceState],
    onChange: props.onChange,
    onRemove: props.onRemove
  });
}
const statusFilterOptions = [{
  label: 'Active',
  value: ActiveServicesReportEntryApiStatus.Active
}, {
  label: 'Amended',
  value: ActiveServicesReportEntryApiStatus.Amended
}];
function StatusFilter(props) {
  return /*#__PURE__*/React.createElement(MultiSelectFilterPicker, {
    removable: true,
    startOpen: props.startOpen,
    "data-testid": "active-services-report-status-filter",
    value: props.value,
    options: statusFilterOptions,
    label: filterLabels[FilterType.Status],
    onChange: props.onChange,
    onRemove: props.onRemove
  });
}
function DateRangePicker(props) {
  const {
    fromDate,
    toDate,
    testid,
    onChange,
    onInputBlur,
    onInputFocus
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(KeyboardDatePicker, {
    label: "From",
    "data-testid": testid && "".concat(testid, "-from"),
    value: fromDate,
    maxDate: toDate,
    onChange: function (_onChange) {
      function onChange(_x) {
        return _onChange.apply(this, arguments);
      }
      onChange.toString = function () {
        return _onChange.toString();
      };
      return onChange;
    }(date => date && onChange && onChange({
      fromDate: date,
      toDate
    })),
    onFocus: onInputFocus,
    onBlur: onInputBlur
  }), /*#__PURE__*/React.createElement(KeyboardDatePicker, {
    label: "To",
    "data-testid": testid && "".concat(testid, "-to"),
    value: toDate,
    minDate: fromDate,
    onChange: function (_onChange2) {
      function onChange(_x2) {
        return _onChange2.apply(this, arguments);
      }
      onChange.toString = function () {
        return _onChange2.toString();
      };
      return onChange;
    }(date => date && onChange && onChange({
      fromDate,
      toDate: date
    })),
    onFocus: onInputFocus,
    onBlur: onInputBlur
  }));
}
function LastBilledInputFilter(props) {
  const {
    value,
    startOpen,
    onChange,
    onRemove,
    onInputBlur,
    onInputFocus
  } = props;
  const {
    getNow
  } = useIoContext();
  const hasDatesFromProps = !!(value !== null && value !== void 0 && value.since && value !== null && value !== void 0 && value.until);
  const [selectingRange, setSelectingRange] = useState(hasDatesFromProps);
  const [since, setSince] = useState(getInitialSince);
  const [until, setUntil] = useState(getInitialUntil);
  useEffect(() => {
    value.since && setSince(new Date(value.since));
  }, [value.since]);
  useEffect(() => {
    value.until && setUntil(new Date(value.until));
  }, [value.until]);
  const label = useMemo(() => {
    const {
      since,
      until
    } = value;
    if (since && until) {
      return "".concat(filterLabels[FilterType.LastBilled], " (").concat(since, "-").concat(until, ")");
    }
    return filterLabels[FilterType.LastBilled];
  }, [value]);
  function onChangeIfDifferentValue(newValue) {
    if (!isEqual(newValue, value)) {
      onChange(newValue);
    }
  }
  function getInitialSince() {
    return value.since != null && value.since != '' ? new Date(value.since) : subMonths(getNow(), 1);
  }
  function getInitialUntil() {
    return value.until != null && value.until != '' ? new Date(value.until) : getNow();
  }
  return /*#__PURE__*/React.createElement(FilterPicker, {
    removable: true,
    startOpen: startOpen,
    "data-testid": "active-services-report-last-billed-filter",
    disableApply: selectingRange && since && until && since > until,
    label: label,
    title: filterLabels[FilterType.LastBilled],
    highlightTrigger: !!(value.since && value.until),
    onRemove: onRemove,
    onApply: () => onChangeIfDifferentValue(selectingRange ? {
      since: since != null ? formatShortUSDate(since) : undefined,
      until: until != null ? formatShortUSDate(until) : undefined
    } : {}),
    onClose: opts => {
      if (opts !== null && opts !== void 0 && opts.revert) {
        setSelectingRange(hasDatesFromProps);
        setSince(getInitialSince());
        setUntil(getInitialUntil());
      }
    }
  }, /*#__PURE__*/React.createElement(RadioButtonWithLabel, {
    label: "Select all",
    testId: "last-billed-filter-all",
    checked: !selectingRange,
    onChange: () => setSelectingRange(false)
  }), /*#__PURE__*/React.createElement(RadioButtonWithLabel, {
    label: "Specific range",
    testId: "last-billed-filter-range",
    checked: selectingRange,
    onChange: () => {
      setSelectingRange(true);
      const now = startOfDay(getNow());
      if (!since) {
        setSince(now);
      }
      if (!until) {
        setUntil(now);
      }
    }
  }), selectingRange && since && until && /*#__PURE__*/React.createElement(DateRangePicker, {
    testid: "last-billed-filter",
    fromDate: since,
    toDate: until,
    onChange: data => {
      setSince(data.fromDate);
      setUntil(data.toDate);
    },
    onInputFocus: onInputFocus,
    onInputBlur: onInputBlur
  }));
}
const lastBilledFilterConfig = {
  component: LastBilledInputFilter,
  hasValue(value) {
    return value.since !== '' || value.until !== '';
  },
  getEmptyValue() {
    return {
      since: undefined,
      until: undefined
    };
  },
  serialize(data) {
    var _data$since, _data$until;
    return {
      lastBilledSince: (_data$since = data.since) !== null && _data$since !== void 0 ? _data$since : '',
      lastBilledUntil: (_data$until = data.until) !== null && _data$until !== void 0 ? _data$until : ''
    };
  }
};
function StringListFilter(label, filterOptions) {
  return function CustomerNameFilterComponent(props) {
    return /*#__PURE__*/React.createElement(MultiSelectFilterPicker, {
      withSearchbox: true,
      removable: true,
      startOpen: props.startOpen,
      "data-testid": "active-services-report-".concat(props.type, "-filter"),
      value: props.value,
      options: filterOptions.map(option => ({
        value: option,
        label: option
      })),
      label: label,
      onChange: props.onChange,
      onRemove: props.onRemove
    });
  };
}
export const makeFiltersConfig = (serviceNames, customerNames, agreementNames, assignees) => ({
  [FilterType.CustomerName]: getSimpleMultiSelectFilterConfig(FilterType.CustomerName, StringListFilter(filterLabels[FilterType.CustomerName], customerNames)),
  [FilterType.ServiceName]: getSimpleMultiSelectFilterConfig(FilterType.ServiceName, StringListFilter(filterLabels[FilterType.ServiceName], serviceNames)),
  [FilterType.AgreementName]: getSimpleMultiSelectFilterConfig(FilterType.AgreementName, StringListFilter(filterLabels[FilterType.AgreementName], agreementNames)),
  [FilterType.Assignee]: getSimpleMultiSelectFilterConfig(FilterType.Assignee, StringListFilter(filterLabels[FilterType.Assignee], assignees)),
  [FilterType.Occurrence]: getSimpleMultiSelectFilterConfig(FilterType.Occurrence, OccurrenceFilter),
  [FilterType.Trigger]: getSimpleMultiSelectFilterConfig(FilterType.Trigger, TriggerFilter),
  [FilterType.Pricing]: getSimpleMultiSelectFilterConfig(FilterType.Pricing, PricingFilter),
  [FilterType.AutomaticServiceState]: getSimpleMultiSelectFilterConfig(FilterType.AutomaticServiceState, AutomaticServiceStatusFilter),
  [FilterType.Status]: getSimpleMultiSelectFilterConfig(FilterType.Status, StatusFilter),
  [FilterType.LastBilled]: lastBilledFilterConfig
});
export function ActiveServicesReport() {
  const businessId = useStore(selectors.user.businessId);
  const {
    api
  } = useStoreActions();
  const history = useHistory();
  const [visibleColumns, setVisibleColumns] = useState({
    [ActiveServicesReportOptionalColumns.Trigger]: false,
    [ActiveServicesReportOptionalColumns.Pricing]: false,
    [ActiveServicesReportOptionalColumns.Occurrence]: true,
    [ActiveServicesReportOptionalColumns.Rate]: true,
    [ActiveServicesReportOptionalColumns.LastBilled]: false,
    [ActiveServicesReportOptionalColumns.Assignee]: false,
    [ActiveServicesReportOptionalColumns.AutomaticServiceState]: false,
    [ActiveServicesReportOptionalColumns.Status]: true
  });
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [availableServices, setAvailableServices] = useState([]);
  const [availableCustomers, setAvailableCustomers] = useState([]);
  const [availableAgreements, setAvailableAgreements] = useState([]);
  const [availableAssignees, setAvailableAssignees] = useState([]);
  const [filteredServices, setFilteredServices] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [filteredAgreements, setFilteredAgreements] = useState([]);
  const [filteredAssignees, setFilteredAssignees] = useState([]);
  const [filteredOccurrences, setFilteredOccurrences] = useState([]);
  const [filteredTriggers, setFilteredTriggers] = useState([]);
  const [filteredPricing, setFilteredPricing] = useState([]);
  const [filteredAutomaticServiceState, setFilteredAutomaticServiceState] = useState([]);
  const [filteredStatus, setFilteredStatus] = useState([]);
  const [filteredLastBilled, setFilteredLastBilled] = useState({
    since: undefined,
    until: undefined
  });
  const [selectedFilters, setSelectedFilters] = useState([]);
  const filtersConfig = useMemo(() => makeFiltersConfig(availableServices, availableCustomers, availableAgreements, availableAssignees), [availableServices, availableCustomers, availableAgreements, availableAssignees]);
  const setters = {
    [FilterType.CustomerName]: setFilteredCustomers,
    [FilterType.ServiceName]: setFilteredServices,
    [FilterType.AgreementName]: setFilteredAgreements,
    [FilterType.Assignee]: setFilteredAssignees,
    [FilterType.Occurrence]: setFilteredOccurrences,
    [FilterType.Trigger]: setFilteredTriggers,
    [FilterType.Pricing]: setFilteredPricing,
    [FilterType.AutomaticServiceState]: setFilteredAutomaticServiceState,
    [FilterType.Status]: setFilteredStatus,
    [FilterType.LastBilled]: setFilteredLastBilled
  };
  const values = {
    [FilterType.CustomerName]: filteredCustomers,
    [FilterType.ServiceName]: filteredServices,
    [FilterType.AgreementName]: filteredAgreements,
    [FilterType.Assignee]: filteredAssignees,
    [FilterType.Occurrence]: filteredOccurrences,
    [FilterType.Trigger]: filteredTriggers,
    [FilterType.Pricing]: filteredPricing,
    [FilterType.AutomaticServiceState]: filteredAutomaticServiceState,
    [FilterType.Status]: filteredStatus,
    [FilterType.LastBilled]: filteredLastBilled
  };
  function addFilter(type) {
    setSelectedFilters(selectedFilters.concat(type));
  }
  function removeFilter(type) {
    setSelectedFilters(selectedFilters.filter(t => t !== type));
    switch (type) {
      case FilterType.CustomerName:
        setFilteredCustomers([]);
        break;
      case FilterType.ServiceName:
        setFilteredServices([]);
        break;
      case FilterType.AgreementName:
        setFilteredAgreements([]);
        break;
      case FilterType.Assignee:
        setFilteredAssignees([]);
        break;
      case FilterType.Occurrence:
        setFilteredOccurrences([]);
        break;
      case FilterType.Trigger:
        setFilteredTriggers([]);
        break;
    }
  }
  useEffect(() => {
    document.title = title;
  }, []);
  useEffect(() => {
    if (businessId == null) return;
    api.reports.activeServicesReportServices({
      businessId
    }).then(setAvailableServices);
    api.reports.activeServicesReportCustomers({
      businessId
    }).then(setAvailableCustomers);
    api.reports.activeServicesReportAgreements({
      businessId
    }).then(setAvailableAgreements);
    api.reports.activeServicesReportAssignees({
      businessId
    }).then(setAvailableAssignees);
  }, [businessId]);
  useEffect(() => {
    if (businessId == null) return;
    setIsRefreshing(true);
    api.reports.activeServicesReport({
      businessId,
      customers: filteredCustomers,
      services: filteredServices,
      agreements: filteredAgreements,
      assignees: filteredAssignees,
      params: {
        occurrence: filteredOccurrences,
        trigger: filteredTriggers,
        pricing: filteredPricing,
        automaticServiceState: filteredAutomaticServiceState,
        status: filteredStatus,
        lastBilledSince: filteredLastBilled.since,
        lastBilledUntil: filteredLastBilled.until
      }
    }).then(data => {
      setReportData(data);
      setIsRefreshing(false);
    });
    // eslint-disable-next-line react-hooks-static-deps/exhaustive-deps
  }, [businessId, filteredServices, filteredCustomers, filteredAgreements, filteredAssignees, filteredOccurrences, filteredTriggers, filteredPricing, filteredLastBilled, filteredAutomaticServiceState, filteredStatus]);
  return /*#__PURE__*/React.createElement(Page, {
    "data-testid": "active-services-report",
    header: "Active Services Report",
    variant: "containedHeight",
    onClickBack: () => history.push(routes.reports),
    actions: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      skin: "primary",
      "data-testid": "export-report-btn",
      onClick: () => exportCsv(makeCsv(activeServicesReportHeaderColumnDefsForExport(visibleColumns).map(_ref3 => {
        let {
          value
        } = _ref3;
        return value;
      }), visibleColumns, reportData), csvFileName)
    }, "Export"))
  }, /*#__PURE__*/React.createElement(TableList.Provider, {
    columnDefs: activeServicesReportColumnDefs(visibleColumns),
    numRows: reportData.length
  }, /*#__PURE__*/React.createElement(PageContentHeader, null, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBlockEnd: '24px'
    }
  }, /*#__PURE__*/React.createElement(FilterPickerGroup, {
    flexWrap: true,
    "data-testid": "active-services-report-filters"
  }, /*#__PURE__*/React.createElement(VisibleColumnsPicker, {
    visibleColumns: visibleColumns,
    onApply: updatedVisibleColumns => setVisibleColumns(updatedVisibleColumns)
  }), selectedFilters.map(type => renderFilterComponent(type, filtersConfig, selectedFilters, values[type], setters[type], removeFilter)), selectedFilters.length < Object.keys(FilterType).length && /*#__PURE__*/React.createElement(FilterSelector, {
    selected: selectedFilters,
    onSelect: addFilter
  })))), /*#__PURE__*/React.createElement(TableList.Structure, {
    header: /*#__PURE__*/React.createElement(TableList.Header, {
      stickyToTop: true,
      items: activeServicesReportHeaderColumnDefs(visibleColumns),
      "data-testid": "active-services-report-table-header"
    }),
    content: isRefreshing ? /*#__PURE__*/React.createElement("div", {
      className: styles.loading,
      "data-testid": "active-services-table-loading"
    }, /*#__PURE__*/React.createElement(Spinner, null)) : reportData.length ? reportData.map((reportRow, index) => /*#__PURE__*/React.createElement(ActiveServiceRow, {
      key: "".concat(reportRow.customerName, "-").concat(reportRow.serviceName, "-").concat(index),
      index: index,
      data: reportRow,
      visibleColumns: visibleColumns
    })) : null
  })));
}
function renderFilterComponent(type, filtersConfig, selectedFilters, value, onChange, onRemoveFilter) {
  return /*#__PURE__*/React.createElement(filtersConfig[type].component, {
    type,
    key: type,
    title: filterLabels[type],
    startOpen: selectedFilters.includes(type),
    value,
    onChange,
    onRemove: () => onRemoveFilter(type)
  });
}
const csvFileName = 'active-services-report.csv';
function makeCsv(headerRow, visibleColumns, entries) {
  return [headerRow].concat(entries.map(entry => {
    const row = [entry.customerName, entry.agreementName, entry.serviceName];
    if (visibleColumns[ActiveServicesReportOptionalColumns.Trigger]) {
      row.push(entry.trigger);
    }
    if (visibleColumns[ActiveServicesReportOptionalColumns.Pricing]) {
      row.push(entry.pricing);
    }
    if (visibleColumns[ActiveServicesReportOptionalColumns.Occurrence]) {
      row.push(entry.occurrence);
    }
    if (visibleColumns[ActiveServicesReportOptionalColumns.Rate]) {
      row.push(entry.rate);
    }
    if (visibleColumns[ActiveServicesReportOptionalColumns.LastBilled]) {
      row.push(entry.formattedLastBilled || '');
    }
    if (visibleColumns[ActiveServicesReportOptionalColumns.Assignee]) {
      row.push(entry.assignee);
    }
    if (visibleColumns[ActiveServicesReportOptionalColumns.AutomaticServiceState]) {
      row.push(entry.automaticServiceState || '');
    }
    if (visibleColumns[ActiveServicesReportOptionalColumns.Status]) {
      row.push(entry.status);
    }
    return row;
  }));
}